export function useChartHasDataCheck() {
  const dataIsDefined = <T>(value: T): value is NonNullable<T> => {
    // return false
    return value !== undefined && value !== null
  }

  const hasData = (data: unknown[]): boolean => {
    // return false
    return data.length > 0
  }

  return {
    dataIsDefined,
    hasData,
  }
}
